export default __webpack_public_path__ + "static/media/cs-go.9508a2f8.png";